<template>
  <div>
    <!-- 编辑模态框 -->
    <el-dialog v-loading="loading" :element-loading-text="loading_text"
      title="上传证书"
      :visible.sync="dialogVisible"
      top="20px"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <div class="border p-3 rounded">
        <div class="yh-section-title">上传证书</div>
        <p v-html="tip" class="el-upload__tip" style="line-height: 18px"></p>

        <el-upload
          ref="upload"
          class="upload-demo"
          multiple
          :limit="2"
          action=""
          :auto-upload="false"
          :accept="accept"
          :before-remove="handleBeforeRemove"
          :on-remove="handleUpLoadRemove"
          :on-change="handleUploadChange"
          :file-list="fileList"
        >
          <el-button size="small" icon="el-icon-plus" slot="trigger">选取附件</el-button>
          <el-button style="margin-left: 10px" size="small" icon="el-icon-upload" type="success" @click="submitUpload" :disabled="fileList.length <= 0">上传并识别</el-button>
          <!-- <el-button slot="trigger" size="mini" type="primary" -->
            <!-- >上传证书文件 -->
          <!-- </el-button> -->
        </el-upload>
      </div>
      <div class="mt-3 clearfix">
        <span class="float-right">
          <el-button
            v-if="dispCloseUploadDiagBtn"
            size="small"
            type="primary"
            @click="handleClose"
            >关闭</el-button
          >
        </span>
      </div>
    </el-dialog>

    <el-dialog
      title="识别结果"
      :visible.sync="dispSuccesHintDiag"
      width="50%"
      v-loading="loading" :element-loading-text="loading_text"
    >
    <template v-if="customer_list.length > 0">
      <el-row>
        <el-select class="w-100" placeholder="请选择客户" @change="handleCustomerChange" v-model="customer_id">
          <el-option v-for="item in customer_list" :key="item.id"
                      :value="item.id"
                      :label="'[' + item.id + '] ' + item.name"></el-option>
        </el-select>
      </el-row>
      <el-row>
        <el-alert v-if="!customer.is_own_group"
          title="当前客户非本部门所属无法导入客户信息"
          type="warning"
          :closable="false"
          show-icon>
        </el-alert>
      </el-row>
      <el-row>
        <el-form>
          <el-row>
            <el-col :span="22">
              <el-divider content-position="left"><span class="title">系统已有的客户信息</span></el-divider>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="客户名称">{{ customer.name }}</el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="证件类型">{{ customer.cert_type_name }}</el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="证件号码">{{ customer.cert_number }}</el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="有效期/发证日">
                  {{ customer.cert_expired }}
                </el-form-item>
              </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="客户类型">{{ customer.type_name }}</el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="地址">{{ customer.address }}</el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-row>
    </template>
      <el-row>
        <el-col :span="24">
          <el-form :rules="rules" ref="dataForm" :model="new_customer" label-position="left" label-width="80px">
            <el-row>
              <el-col :span="22">
                <el-divider content-position="left"><span class="title">识别结果</span></el-divider>
              </el-col>
            </el-row>
            <el-row type="flex" justify="space-between">
              <el-col :span="10">
                <!-- 客户名称 -->
                <el-form-item label="客户名称" prop="name">
                  <el-input :disabled="disInput" v-model="new_customer.name" placeholder="请输入客户名称"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="证件类型" prop="cert_type">
                  <el-select :disabled="disInput" class="filter-item" v-model="new_customer.cert_type" filterable placeholder="请选择客户类型">
                    <el-option v-for="(type, index) in file_type_list" :key="index" :label="type.value" :value="type.code">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row type="flex" justify="space-between">
              <el-col :span="10">
                <el-form-item label="证件号码" prop="cert_number">
                  <el-input :disabled="disInput" v-model="new_customer.cert_number" placeholder="请输入证件号码" ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="有效期/发证日" prop="cert_expired">
                  <el-date-picker v-model="new_customer.cert_expired"
                                  type="date" value-format="yyyy-MM-dd"
                                  placeholder="有效期/发证日" class="w-100"></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row type="flex" justify="space-between">
              <el-col :span="10">
                <el-form-item label="客户类型" prop="type">
                <el-select :disabled="disInput" class="filter-item" v-model="new_customer.type" filterable placeholder="请选择客户类型">
                  <el-option v-for="(type, index) in type_list" :key="index" :label="type.value" :value="type.code">
                  </el-option>
                </el-select>
              </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="地址" prop="address">
                  <el-input v-model="new_customer.address" placeholder="请输入地址" ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dispSuccesHintDiag = false">取 消</el-button>
        <el-button type="primary" @click="handleImportCert" :disabled="!customer.is_own_group" v-if="customer_list.length > 0"
          >更新客户</el-button
        >
        <el-button type="primary" @click="handleCreateCustomer"
          >创建客户</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      title="识别出错"
      :visible.sync="dispErrHintDiag"
      width="50%" v-loading="loading" :element-loading-text="loading_text"
    >
      <span>{{ serverErrMessage }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dispErrHintDiag = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
  
  <script>
/* eslint-disable */

import { uploadCert, importCert, createCustomerByCert } from "@/api/customer";
import { fetchFileTypeList, fetchDictList } from '@/api/common'

export default {
  name: "customer-upload-cert-dialog",
  computed: {
    disInput() {
      let res = true
      if (this.$perm(['customer.force_change_customer'])) {
        res = false
      }
      return res
    },
  },
  data() {
    return {
      tip:
        "1. 证书文件为图片文件(.png,.jpg,.jpeg)，文件大小不应超过10MB。<br>" +
        "2. 如证书文件有正反两份，可同时选取两张图片上传<br>",
      accept: ".png,.jpg,.jpeg,.pdf",
      temp: {},
      dialogVisible: false,
      rules: {},
      dispCloseUploadDiagBtn: true,
      dispErrHintDiag: false,
      dispSuccesHintDiag: false,
      serverErrMessage: "",
      customer: {},
      new_customer: {
        name: '',
        cert_type: null,
        cert_number: '',
        cert_expired: null,
        address: '',
      },
      fileList: [],
      customer_list: [],
      customer_id: 0,
      file_path_list: [],
      cert_analy: {},
      file_type_list: [],
      loading: false,
      loading_text: '',
      type_list: [],
    };
  },
  methods: {
    handleCustomerUploadCert() {
      this.dialogVisible = true;
    },
    reset_new_customer() {
      this.new_customer = {}
    },
    handleCustomerChange(customer_id) {
      this.customer = this.customer_list.find(customer => {
        return (customer.id === customer_id)
      })
    },
    handleClose() {
      this.fileList = []
      this.$refs.upload.clearFiles();
      this.dialogVisible = false;
    },
    handleBeforeRemove(file, filelist) {
      return this.$confirm(`确定移除 ${file.name}？`)
    },
    handleUpLoadRemove(file, fileList) {
      let tempFileList = []
      for (var index = 0; index < this.fileList.length; index++) {
        if (this.fileList[index].name !== file.name) {
          tempFileList.push(this.fileList[index])
        }
      }
      this.fileList = tempFileList
    },
    handleUploadChange(file, fileList) {
      let existFile = fileList.slice(0, fileList.length - 1).find(f => f.name === file.name);
      let isGte10M = file.size / 1024 / 1024 >= 10;
      if (existFile) {
        this.$message.error(`文件${file.name}已经存在!`);
        fileList.pop();
      } else if (isGte10M) {
        this.$message.error(`上传的文件大小不能超过10MB，文件${file.name}大小超出限制`);
        fileList.pop();
      }
      this.fileList = fileList;
    },
    handleUploadSuccess(res) {
      this.dispCloseUploadDiagBtn = true;
      this.dispErrHintDiag = false;
      this.$message.success('识别成功');
      this.handleClose();
      this.customer_list = res[0].customer_list
      this.file_path_list = res[0].file_path_list
      this.new_customer = res[0].cert_analy
      this.file_type_list = res[1]
      this.type_list = res[2]
      if (this.customer_list.length > 0) {
      this.customer_id = this.customer_list[0].id
      this.customer_id = this.customer_list[0].id
      this.file_type_list = res[1]
        this.customer_id = this.customer_list[0].id
      this.file_type_list = res[1]
        this.customer_list.forEach(item => {
          let file_type = this.file_type_list.find(file_type => {
            return (file_type.code === item.cert_type)
          })
          if (file_type) {
            item.cert_type_name = file_type.value
          } else {
            item.cert_type_name = '未填写'
          }
          // 处理扩展字段
          if (JSON.stringify(item.ext_info) !== "{}") {
            Object.keys(item.ext_info).forEach(key => {
              this.$set(item, key, item.ext_info[key])
            })
            item.ext_info = undefined
          }
        })
        this.handleCustomerChange(this.customer_id)
      }
      this.dispSuccesHintDiag = true
      this.loading = false
    },
    handleUploadError(error) {
      this.handleClose();
      this.serverErrMessage = error.message;
      this.dispCloseUploadDiagBtn = true;
      this.dispErrHintDiag = true;
      this.loading = false
      // error_message(error)
    },
    submitUpload() {
      let fd = new FormData();
      this.fileList.forEach(item => {
        fd.append('file', item.raw)
      })
      let p = []
      this.loading = true
      this.loading_text = '正在识别中'
      p.push(uploadCert(fd))
      p.push(fetchFileTypeList({file_type: 'cc'}))
      p.push(fetchDictList({type: 'customer.type'}))
      Promise.all(p)
        .then((res) => {
          this.handleUploadSuccess(res);
        })
        .catch((error) => {
          this.handleUploadError(error);
        });
    },
    handleImportCert() {
      this.loading_text = '正在保存中'
      this.loading = true
      let form = this.new_customer
      form['file_path_list'] = this.file_path_list
      importCert(this.customer_id, form).then(res => {
        this.loading = false
        this.$refs.dataForm.clearValidate()
        this.$refs.dataForm.resetFields()
        this.reset_new_customer()
        this.dispSuccesHintDiag = false
        this.$message.success('保存客户信息和客户附件成功')
        this.$emit("updateList")
      }).catch(error => {
        this.loading = false
        this.$message.error(error)
      })
    },
    handleCreateCustomer() {
      this.loading_text = '正在保存中'
      this.loading = true
      let form = this.new_customer
      form['file_path_list'] = this.file_path_list
      createCustomerByCert(form).then(res => {
        this.loading = false
        this.$refs.dataForm.clearValidate()
        this.$refs.dataForm.resetFields()
        this.reset_new_customer()
        this.dispSuccesHintDiag = false
        this.$message.success('保存客户信息和客户附件成功')
        this.$emit("updateList")
      }).catch(error => {
        this.loading = false
        this.$message.error(error)
      })
    },
  },
};
</script>